import {
  GET_DOCUMENT_RENEWAL_TARGETS, GET_DOCUMENT_RENEWAL_TARGETS_SUCCESS, GET_DOCUMENT_RENEWAL_TARGETS_FAILURE,
  CREATE_DOCUMENT_RENEWAL, CREATE_DOCUMENT_RENEWAL_SUCCESS, CREATE_DOCUMENT_RENEWAL_FAILURE
} from './mutation-types'

//
// 書類の更新提出（P12）
//
export default {
  state: {
    documentRenewalTargets: null,
    documentRenewalError: null
  },
  getters: {
    // 期限接近書類（本人宛の期限お知らせ ＋ 直近の提出状況）
    documentRenewalTargets: state => {
      return state.documentRenewalTargets
    },
    documentRenewalCount: state => {
      return state.documentRenewalTargets ? state.documentRenewalTargets.length : 0
    },
    documentRenewalError: state => {
      return state.documentRenewalError
    }
  },
  actions: {
    [GET_DOCUMENT_RENEWAL_TARGETS] ({dispatch, state, commit}, params = null) {
      return dispatch('apiGet', {url: '/asovi/document_renewals', data: {}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_DOCUMENT_RENEWAL_TARGETS_FAILURE, res.data)
          } else {
            commit(GET_DOCUMENT_RENEWAL_TARGETS_SUCCESS, {data: res.data, callback: params ? params.callback : null})
          }
        }
      })
      .catch(error => {
        console.log('GET_DOCUMENT_RENEWAL_TARGETS error', error)
        commit(GET_DOCUMENT_RENEWAL_TARGETS_FAILURE, {})
        if (params && params.callback) params.callback()
      })
    },
    // 更新書類のアップロード（multipart）
    [CREATE_DOCUMENT_RENEWAL] ({dispatch, state, commit}, params) {
      state.documentRenewalError = null
      return dispatch('apiPost', {url: '/asovi/document_renewals', data: params.data, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CREATE_DOCUMENT_RENEWAL_FAILURE, res.data)
            if (params.errorCallback) params.errorCallback(res.data.error)
          } else {
            commit(CREATE_DOCUMENT_RENEWAL_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        console.log('CREATE_DOCUMENT_RENEWAL error', error)
        commit(CREATE_DOCUMENT_RENEWAL_FAILURE, {error: '提出に失敗しました。通信環境をご確認ください。'})
        if (params.errorCallback) params.errorCallback(state.documentRenewalError)
      })
    }
  },
  mutations: {
    [GET_DOCUMENT_RENEWAL_TARGETS_FAILURE] (state, data) {
      console.log('GET_DOCUMENT_RENEWAL_TARGETS_FAILURE')
      state.documentRenewalTargets = []
    },
    [GET_DOCUMENT_RENEWAL_TARGETS_SUCCESS] (state, data) {
      console.log('GET_DOCUMENT_RENEWAL_TARGETS_SUCCESS')
      state.documentRenewalTargets = data.data.data
      if (data.callback) {
        data.callback()
      }
    },
    [CREATE_DOCUMENT_RENEWAL_FAILURE] (state, data) {
      console.log('CREATE_DOCUMENT_RENEWAL_FAILURE')
      state.documentRenewalError = data.error
    },
    [CREATE_DOCUMENT_RENEWAL_SUCCESS] (state, data) {
      console.log('CREATE_DOCUMENT_RENEWAL_SUCCESS')
      if (data.callback) {
        data.callback(data.data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/document-renewal.js